import { useState } from "react"
import { Controls, WelcomeDialog } from "../components"
import { Calendar } from "../components/Calendar/Calendar"
import { useData } from "../hooks/useData"
import { Header } from "./Header/Header"
import brandHorizontal from '../assets/brandHorizontal.svg'
import brandVertical from '../assets/brandVertical.svg'
import './Layout.scss'

export function Layout() {
  const [ showModal, setShowModal ] = useState(true)
  const { orientation, changeOrientation, print } = useData()

  const onRotate = () => {
    changeOrientation(orientation === 'vertical' ? 'horizontal' : 'vertical')
  }

  const onPrint = () => {
    print()
  }

  return (
    <main className={`${orientation}`}>
      <WelcomeDialog open={showModal} onClose={() => setShowModal(false)} />
      
      <Controls onRotate={onRotate} onPrint={onPrint} />

      <Calendar />

      <img
        className="logo"
        src={orientation === 'horizontal' ? brandHorizontal : brandVertical}
        alt="Logo da Fundação Japão"
      />
    </main>
  )
}